export const SET_THEME = "SET_THEME"

export function setTheme(status) {
  return { type: SET_THEME, status }
}
